<script setup lang="ts">
  import FormHeading from '@/components/form/FormHeading.vue'
  import { FormInput, FormFieldContainer, SwitchButton } from '@logistiek-zonder-papier/lzp-library'
  import JourneyLastCreated from '@/components/idf-modal/JourneyLastCreated.vue'
  import JourneyQualityCode from '@/components/idf-modal/JourneyQualityCode.vue'
  import type {
    IdfJourneyTemplateGrondbank,
    JourneyValidationErrors,
  } from '@/types/idf-journey-product'

  const model = defineModel<IdfJourneyTemplateGrondbank>({ required: true })
  const checked = defineModel<boolean>('repeat', { required: true })

  defineProps<{
    visibleErrors: JourneyValidationErrors
    warningGrondbank: string | null
    isEdit: boolean
  }>()

  const emit = defineEmits<{
    (e: 'fetchCodes'): void
    (e: 'toggleRepeat'): void
  }>()
</script>

<template>
  <FormHeading label="Grondbank" />

  <FormInput
    label="Grondtransportmelding"
    placeholder="Documentnummer"
    v-model="model.stroomNameGrondbank"
    :error="visibleErrors.stroomNameGrondbank"
    :data-validation-error="!!visibleErrors.stroomNameGrondbank || warningGrondbank !== null"
    :warning="isEdit ? null : warningGrondbank"
  />

  <JourneyLastCreated />
  <br />

  <JourneyQualityCode
    label="Kwaliteit code"
    placeholder="Kwaliteit code"
    button-label="Haal codes op"
    v-model="model"
    @fetch="emit('fetchCodes')"
  />

  <FormInput label="Partijnummer TOP" placeholder="Partijnummer TOP" v-model="model.partijNummer" />

  <FormFieldContainer label="Repeterende vrachten" class="extra-bottom-padding">
    <SwitchButton v-model="checked" @change="emit('toggleRepeat')" />
  </FormFieldContainer>
</template>

<style scoped>
  .extra-bottom-padding {
    padding-bottom: 0.5rem;
  }
</style>
